webpackJsonp([133536348556271],{

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(25);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var About = function About() {
	  return _react2.default.createElement(
	    'main',
	    { className: 'myMain' },
	    _react2.default.createElement(_reactHelmet2.default, { title: 'Contacts' }),
	    _react2.default.createElement(
	      'section',
	      { className: 'contacts__wrapper' },
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'columns' },
	          _react2.default.createElement(
	            'div',
	            { className: 'contacts' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'h1' },
	              '\u041E\u041E\u041E \xAB\u0425\u044D\u0434\u043C\u0435\u0439\u0434\xBB'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'icon message' },
	              _react2.default.createElement(
	                'a',
	                { href: 'mailto:info@headmade.pro', className: 'icon__link' },
	                'info@headmade.pro'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'icon phone' },
	              _react2.default.createElement(
	                'a',
	                { href: 'tel:+78432599923', className: 'icon__link' },
	                '+7(843)259-99-23'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'icon map' },
	              _react2.default.createElement(
	                'a',
	                { className: 'icon__link' },
	                '\u0433. \u041A\u0430\u0437\u0430\u043D\u044C, \u0443\u043B.\u041A\u0430\u0440\u043B\u0430 \u041C\u0430\u0440\u043A\u0441\u0430, \u0434.5, \u043F\u043E\u043C\u0435\u0449\u0435\u043D\u0438\u0435 115'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'icon' },
	              _react2.default.createElement(
	                'a',
	                { className: 'icon__link' },
	                '\u0418\u041D\u041D: 16571119572'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'icon' },
	              _react2.default.createElement(
	                'a',
	                { className: 'icon__link' },
	                '\u041E\u041A\u0412\u042D\u0414: 62.09'
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = About;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contacts-js-241b6b375c783b147ae6.js